// extracted by mini-css-extract-plugin
export default {"mentionEdit":"styles_mentionEdit__ETV9W","popoverCommentEdit":"styles_popoverCommentEdit__sUuur"};